'use es6';

import { COURSE_TYPE_ID } from '../../../data/objectTypeIds';
import ObjectDefinitionRecord from '../ObjectDefinitionRecord';
const Course = ObjectDefinitionRecord({
  enableAsAssociatedType: true,
  hasAccess: (_isUngated, hasScope) => hasScope('courses-access'),
  objectTypeId: COURSE_TYPE_ID,
  referenceObjectType: 'COURSE_PROPERTIES'
});
export default Course;